<div class="flex flex-col gap-2">
  @for (item of units(); track item.einheit.id) {
  <soft-ds-item [interactive]="true" (activate)="resolve(item)">
    <soft-ds-item-title>{{ item.einheit.arteh }}</soft-ds-item-title>
    @if (item.dimension?.massUnitId) {
    <soft-ds-item-description>{{ item.dimension.massUnitId }}</soft-ds-item-description>
    }
    <soft-ds-item-trailing>
      @if ($safeNavigationMigration(item?.menge) | isDefined) {
        <span class="text-sm italic">{{ item?.menge }} EH</span>
      }
      <soft-ds-icon name="fa-regular fa-chevron-right" />
    </soft-ds-item-trailing>
  </soft-ds-item>
  }
</div>
